import React from 'react'
import styled from 'styled-components'
import { MyBtn } from '../ui/MyBtn'
import { SwapLeftOutlined } from '@ant-design/icons'
import { useRouter } from 'next/router'

const StyledPageCrumbs = styled.div<{
  center: boolean
  dark: boolean
}>`
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  justify-content: ${props => (props.center ? 'center' : 'space-between')};
  .crumbs-body {
    display: flex;
    align-items: center;
  }
  .crumbs-back {
    margin-right: 16px;
    color: ${props =>
      props.dark
        ? props.theme['neutral-800']
        : props.theme['neutral-200']} !important;
    border-color: ${props =>
      props.dark
        ? props.theme['neutral-300']
        : props.theme['neutral-600']} !important;
  }
  .crumbs-title {
    font-size: 40px;
    line-height: 48px;
    font-weight: 600;
    word-break: break-all;
    color: ${props =>
      props.dark ? props.theme['neutral-800'] : props.theme['neutral-200']};
  }
`

export const PageCrumbs: React.FC<{
  title: React.ReactNode
  hasBack?: boolean
  center?: boolean
  extra?: React.ReactNode
  dark?: boolean
  className?: string
  style?: React.CSSProperties
}> = ({
  title,
  hasBack = false,
  center = false,
  extra,
  dark = false,
  className,
  style,
}) => {
  const router = useRouter()
  return (
    <StyledPageCrumbs
      center={center}
      dark={dark}
      className={className}
      style={style}
    >
      <div className="crumbs-body">
        {hasBack && (
          <MyBtn
            className="crumbs-back"
            $dark={dark}
            onClick={() => router.back()}
          >
            <SwapLeftOutlined /> 返回
          </MyBtn>
        )}
        <span className="crumbs-title">{title}</span>
      </div>
      {extra && <div className="crumbs-action">{extra}</div>}
    </StyledPageCrumbs>
  )
}
